import styled from "styled-components/macro";
import {
  cardBorder,
  eosHeader,
  machineBreakdownGrey,
} from "../../constants/colors";
import { FONT_SIZE_MEDIUM, BREAKPOINT_MOBILE } from "../../constants/constants";
import { EOS_TOP_PADDING_PX, EOS_TOP_PADDING_PRINT_PX } from "./eosConstants";

const CardWrapperStyles = styled.div`
  margin: 10px 20px 0px;
  background-color: ${machineBreakdownGrey};
  position: relative;
  .children {
    background-color: white;
    border-radius: 10px;
    border: 1px solid ${cardBorder};
    padding-bottom: ${EOS_TOP_PADDING_PX}px;
    font-family: "Open Sans";

    .header {
      padding: ${EOS_TOP_PADDING_PX}px 0 5px;
      color: ${eosHeader};
      text-align: center;
      font-size: ${FONT_SIZE_MEDIUM}px;
      font-family: "GothamBold";
    }

    .subHeader {
      color: #a4a4a4;
      text-align: center;
      padding-bottom: ${EOS_TOP_PADDING_PX}px;
      font-family: "GothamLight";
    }
    .headerTimeZone {
      color: #a4a4a4;
      text-align: center;
      font-family: "GothamLight";
      font-size: 12px;
    }
  }

  @media print {
    .headerTimeZone {
      display: none;
    }
    margin: 10px 20px 0px;

    .children {
      padding-bottom: ${EOS_TOP_PADDING_PRINT_PX}px;

      .header {
        padding: ${EOS_TOP_PADDING_PRINT_PX}px 0 5px;
      }

      .subHeader {
        padding-bottom: ${EOS_TOP_PADDING_PRINT_PX}px;
      }
    }
  }

  @media (max-width: ${BREAKPOINT_MOBILE}px) {
    margin: 10px 10px 0;
  }
`;

export const TwoColumnCardStyles = styled.div`
  display: grid;
  grid-template-columns: 50% 50% !important;
  align-items: stretch;
  *:nth-child(1) {
    padding-right: 5px;
  }
  *:nth-child(2) {
    padding-left: 5px;
  }
`;

export default function CardWrapper({ children }: { children: any }) {
  return (
    <CardWrapperStyles>
      <div className="children">{children}</div>
    </CardWrapperStyles>
  );
}
